export default {
  Trending: { color: '#736cd2' },
  'How-to': { color: '#ba3d5d' },
  Creators: { color: '#736cd2' },
  Inspiration: { color: '#ba3d5d' },
};
